import { Injectable, inject } from '@angular/core';
import ServiceRestServices from '../services/service-rest.service';
import Config from '../utils/config.service';
import Time from '../utils/timer.service';
import DialogServices from '../services/dialog.service';
import NotificationService from '../services/notification.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../services/angular-broadcast-helper.service';
import AngularStateHelperService from '../services/angular-state-helper.service';
import moment from 'moment';
import { ModalNotificationComponent } from '../components/modal-notification/modal-notification.component';

@Injectable({ providedIn: 'root' })
export default class InstantBookingService {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private config: Config = inject(Config);
	private time: Time = inject(Time);
	private dialogServices: DialogServices = inject(DialogServices);
	private notificationService: NotificationService = inject(NotificationService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	
	store: any = undefined;
	
	constructor() {
		this.store = {
			// requests: [],
			// fetchedRequests: [],
			// isFetchingRequests: false,
			// lastSavedIsAvailable: false,
			availability: {},
			availabilityTimerId: 'IBS_TOGGLE_AVAILABLE_STATUS_TIMER',
			pollingTimerId: 'IBS_INSTANT_REQUESTS_POLLING_TIMER',
			expiryTimerId: 'IBS_REQUEST_EXPIRY_TIMER',
			expiryTimerInterval: 1000,
			requestsPollingInterval: 10000,
			requestsCount: 0,
			statusCheckDelay: this.config.getBookingConfig().Instant.SECONDS_STATUS_AVAILABLE * 1000,
			statusConfirmDelay: this.config.getBookingConfig().Instant.SECONDS_STATUS_CONFIRM * 1000,
		};
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.UPDATE, () => { this.handleAvailabilityStatusInit(); });
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.LOGIN, (event, data) => {
			this.store.session = this.angularStateHelperService.getGlobalProperty('session');
			this.handleAvailabilityStatusInit(this.store.session.user);
		});
	}
	
	handleRequestsTimeLeft() {
		if (typeof this.store.fetchedRequests === 'undefined') return;
		if (!this.store.fetchedRequests.length) {
			this.store.requests = [];
			this.store.requestsCount = 0;
			return;
		}
		var currentDate: any = moment();
		var requests: any = this.store.fetchedRequests.slice();
		
		requests.forEach((request) => { this.calculateTimeLeft(request, currentDate); });
		console.log('Instant requests:', requests);
		
		var filteredRequests: any = requests.filter((request) => { return !request.isExpired && !request.isAccepted; });
		console.log('Instant requests passed:', filteredRequests.length + '/' + requests.length);
		
		if (!filteredRequests.length) this.handleRequestsExpiryTimerDestroy();
		this.handleNewRequestNotifications(filteredRequests);
		
		this.store.requests = filteredRequests;
		this.store.requestsCount = filteredRequests.length;
	}
	
	handleNewRequestNotifications(requests) {
		if (!requests || !requests.length) return;
		var oldRequests: any = this.store.requests || [];
		var newIds: any = requests.map((request) => {
			var isNew: any = !oldRequests.filter((oldRequest) => { return oldRequest.id === request.id; }).length;
			return isNew ? request.id : null;
		}).filter((request) => {
			return !!request;
		});
		
		if (!newIds || !newIds.length) return;
		var opts: any = {
			type: 'instantBooking',
			showAlways: true,
			lastId: Math.max(newIds),
			title: this.angularFilterHelperService.translate('Services.Other.New_Bookings'),
			body: this.angularFilterHelperService.translate('Services.Other.Proceed_To_Accept'),
			onClick: () => {
				this.angularRoutingHelperService.setPath('/bookings/instant');
			},
		};
		this.notificationService.displayPushNotification(opts);
	}
	
	calculateTimeLeft(booking, currentDate) {
		currentDate = currentDate || moment();
		
		var diff: any = moment(booking.modified).add(this.config.getBookingConfig().Instant.SECONDS_PENDING, 'seconds').diff(currentDate);
		var duration: any = moment.duration(diff, 'milliseconds');
		booking.isExpired = duration.asMilliseconds() <= 0;
		
		if (!booking.isExpired) {
			var minutes: any = Math.floor(duration.asMinutes());
			var seconds: any = Math.floor(duration.asSeconds()) - minutes * 60;
			booking.timeLeft = minutes + ':' + ('0' + seconds).slice(-2);
		} else {
			booking.timeLeft = '0:00';
		}
	}
	
	handleRequestsExpiryTimerInit() {
		this.handleRequestsExpiryTimerDestroy();
		this.handleRequestsTimeLeft();
		this.time.newTimer(this.store.expiryTimerId, () => {
			this.handleRequestsTimeLeft();
		}, this.store.expiryTimerInterval);
	}
	
	handleRequestsExpiryTimerDestroy() {
		if (this.time.getTimer(this.store.expiryTimerId)) this.time.deleteTimer(this.store.expiryTimerId);
	}
	
	handleAvailabilityStatusInit(user?) {
		if (!this.isAllowed(user)) return;
		
		this.getInstantAvailabilityStatus()
			.then((res) => {
				this.store.availability = this.angularHelperService.copy(res);
				this.store.lastSavedIsAvailable = this.angularHelperService.copy(res.available);
				if (res.available) {
					this.handleStatusCheckInit();
					this.handleRequestsPollingInit();
				}
			}, (err) => {
				console.error(err);
			});
	}
	
	handleAvailabilityStatusSave() {
		var isServiceAvailable: any = this.store.availability.available;
		var status: any = isServiceAvailable ? 'ONLINE' : 'OFFLINE';
		if (this.store.lastSavedIsAvailable === isServiceAvailable || !this.isAllowed()) return;
		
		this.serviceRestServices.setInstantBookingAvailabilityStatus({ status: status }, {}, (availability) => {
			this.store.availability = availability;
			this.store.lastSavedIsAvailable = isServiceAvailable;
			if (isServiceAvailable) {
				this.handleStatusCheckInit();
				this.handleRequestsPollingInit();
			} else {
				this.handleStatusCheckDestroy();
				this.handleRequestsPollingDestroy();
				this.handleRequestsExpiryTimerDestroy();
				delete this.store.requests;
				this.store.requestsCount = 0;
			}
		}, (err) => {
			console.error(err);
			if (err.status !== 511) {
				// stop setting up availability updates/checks if user is logged out
				if (this.store.lastSavedIsAvailable !== isServiceAvailable) this.toggleAvailabilityStatus(false);
			}
			this.store.lastSavedIsAvailable = false;
			this.handleRequestsPollingDestroy();
		});
	}
	
	getInstantAvailabilityStatus() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.serviceRestServices.getInstantAvailabilityStatus((res) => {
			deferred.resolve({ available: res?.available ?? false, ...res });
		}, (err) => {
			deferred.reject(err);
		});
		
		return deferred.promise;
	}
	
	handleStatusConfirmInit() {
		this.handleStatusConfirmDestroy();
		if (!this.isAllowed()) return;
		
		this.handleCallbackIfStatusUnchanged(() => {
			var dialog = this.dialogServices.confirmation({
				content: this.angularFilterHelperService.translate('Booking.Instant.Status_Confirmation'),
				bindings: {
					closeDelay: this.store.statusConfirmDelay
				},
			});
			dialog.afterClosed().subscribe(
				(res) => {
					if (res && res.isAccepted) {
						this.toggleAvailabilityStatus(true);
						this.handleStatusConfirmDestroy();
					}
				},
				() => {
					this.toggleAvailabilityStatus(false, true);
					this.handleStatusConfirmDestroy();
				}
			);
			
			this.store.statusConfirmTimer = this.angularHelperService.createTimer(() => {
				this.handleCallbackIfStatusUnchanged(() => {
					this.toggleAvailabilityStatus(false, true);
				});
			}, this.store.statusConfirmDelay);
		});
	}
	
	handleCallbackIfStatusUnchanged(callback) {
		this.getInstantAvailabilityStatus()
			.then((res) => {
				if (this.store.availability && this.store.availability.modified === res.modified) {
					if (typeof callback === 'function') callback();
				} else {
					this.store.availability = this.angularHelperService.copy(res);
					this.store.lastSavedIsAvailable = this.angularHelperService.copy(res.available);
					if (res.available) {
						this.handleStatusCheckInit();
						this.handleRequestsPollingInit();
					}
				}
			})
			.catch(console.error);
	}
	
	handleStatusConfirmDestroy() {
		if (this.store.statusConfirmTimer) this.angularHelperService.cancelTimer(this.store.statusConfirmTimer);
	}
	
	handleStatusCheckInit() {
		this.handleStatusCheckDestroy();
		var delay: any = Math.max(0, this.store.statusCheckDelay - moment().diff(moment(this.store.availability.modified)));
		this.store.statusCheckTimer = this.angularHelperService.createTimer(() => {
			this.handleStatusConfirmInit();
		}, delay);
	}
	
	handleStatusCheckDestroy() {
		if (this.store.statusCheckTimer) this.angularHelperService.cancelTimer(this.store.statusCheckTimer);
	}
	
	handleRequestsPollingInit() {
		this.handleRequestsPollingDestroy();
		this.store.isFetchingRequests = false;
		this.fetchRequests();
		this.time.newTimer(this.store.pollingTimerId, () => { this.fetchRequests(); }, this.store.requestsPollingInterval);
	}
	
	handleRequestsPollingDestroy() {
		if (this.time.getTimer(this.store.pollingTimerId)) this.time.deleteTimer(this.store.pollingTimerId);
	}
	
	fetchRequests() {
		if (this.store.isFetchingRequests) return;
		this.store.isFetchingRequests = true;
		
		var searchParams: any = {
			origin: this.store.session.user.origin
		};
		this.serviceRestServices.getInstantBookingRequests(searchParams, (res) => {
			res = res || [];
			res.forEach((item) => { if (item.languages) item.languages = item.languages.split(','); });
			this.store.fetchedRequests = res || [];
			this.store.isFetchingRequests = false;
			if (this.store.fetchedRequests.length && !this.time.getTimer(this.store.expiryTimerId)) this.handleRequestsExpiryTimerInit();
			if (!this.store.fetchedRequests.length && this.time.getTimer(this.store.expiryTimerId)) this.handleRequestsExpiryTimerDestroy();
			if (!this.store.fetchedRequests.length && !this.time.getTimer(this.store.expiryTimerId)) {
				this.store.requests = [];
				this.store.requestsCount = 0;
			}
		}, (err) => {
			console.error(err);
			this.store.isFetchingRequests = false;
			if (err.status == 511) {
				this.handleRequestsPollingDestroy();
			}
		});
	}
	
	getRequests() {
		return this.store.requests;
	}
	
	getRequestsCount() {
		return this.store.requestsCount;
	}
	
	isAvailable() {
		return this.store.availability.available;
	}
	
	isAllowed(user?) {
		if (!user && this.store.session && this.store.session.user) {
			user = this.store.session.user;
		}
		var allowedCategories: Array<any> = ['PHARMACIST', 'GENERAL_PRACTITIONER', 'FAMILY_PHYSICIAN'];
		
		return user
			&& user.businessUserType === 'SERVICE_PROVIDER'
			&& !!user.service
			&& user.service.onDemandServiceProvider
			&& allowedCategories.indexOf(user.service.furtherSubcategory) !== -1;
	}
	
	toggleAvailabilityStatus(isServiceAvailable, isInstant?) {
		if (!this.isAllowed()) return;
		if (typeof isServiceAvailable === 'undefined') {
			this.store.availability.available = !this.store.availability.available;
		} else {
			this.store.availability.available = isServiceAvailable;
			this.store.lastSavedIsAvailable = undefined;
		}
		
		var timerId: any = this.store.availabilityTimerId;
		var delay: any = isInstant ? undefined : this.config.getOtherConfig().LOADER_TIMEOUT_DELAY;
		this.angularHelperService.cancelTimer(this.store[timerId]);
		this.store[timerId] = this.angularHelperService.createTimer(() => { this.handleAvailabilityStatusSave(); }, delay);
	}
	
	acceptPendingRequest(request) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.serviceRestServices.acceptInstantBookingRequest({ bookingId: request.id }, (res) => {
			deferred.resolve();
			this.handlePendingRequestSuccess(request);
		}, (err) => {
			console.log(err);
			deferred.reject(err.error[0]);
			this.handlePendingRequestFailure(err);
		});
		
		return deferred.promise;
	}
	
	handlePendingRequestSuccess(request) {
		request.isAccepted = true;
		
		this.dialogServices.show({
			controller: ModalNotificationComponent,
			title: this.angularFilterHelperService.translate('Booking.Confirmed'),
			text: this.angularFilterHelperService.translate('Booking.Instant.Confirmed'),
		});
		
		this.angularRoutingHelperService.setPath('/bookings/upcoming');
		this.store.requests = this.store.requests.filter(function(item) { return item.id !== request.id; });
		this.store.requestsCount = this.store.requests.length;
	}
	
	handlePendingRequestFailure(err) {
		var errMessage: any = err.error[0];

		this.dialogServices.show({
			controller: ModalNotificationComponent,
			title: this.angularFilterHelperService.translate('Booking.Instant.Error.Title'),
			text: this.angularFilterHelperService.translate('Booking.Instant.Error.' + errMessage.model + '_' + errMessage.property + '_' + errMessage.message),
		});
	}
	
}